import { redirect } from "react-router-dom"
import { calcStartDate } from "@/utils/calc-start-date-util"
import { getPreviousDate } from "@/utils/get-previous-date"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import { aptEnsureLoaded } from "../../apt-ensure-loaded"

export const reportLoader = async ({ request, params }) => {
  await aptEnsureLoaded(params)

  const url = new URL(request.url)
  const startDate = url.searchParams.get("start_date")
  const endDate = url.searchParams.get("end_date")

  if (startDate && endDate) return null
  const { ended_at } = aptSearchStore.getState().pickApt

  url.searchParams.set(
    "start_date",
    startDate || getPreviousDate(calcStartDate(ended_at, "months"))
  )
  url.searchParams.set("end_date", endDate || getPreviousDate(ended_at))

  throw redirect(`${url.pathname}?${url.searchParams.toString()}`)
}
